import { styled } from '@mui/material';
import { VtaasRole } from '@providers/User/vtaasRole';

export const currentYear = new Date().getFullYear();

export const allowedRoles = [VtaasRole.ADMIN, VtaasRole.SAMSONVT];

export const StyledA = styled('a')`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  text-decoration: underline;
`;
